<aa-action-circle class="" [ngClass]="(filterStatus | async) ? 'blue': 'grey'" [faIcon]="'fal fa-sliders-h'">
</aa-action-circle>
